import React, { useState } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name || !formData.email || !formData.message) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Please fill in all fields!',
            });
            return;
        }
        const response = await axios.post(`${process.env.REACT_APP_API_URL}`, {
            action: 'ContactUs',
            name: formData.name,
            email: formData.email,
            message: formData.message
        });
        const dataEdit = response.data;
        if (dataEdit.status === true) {
            Swal.fire({
                icon: 'success',
                title: 'Form Submitted!',
                text: 'Thank you for your submission.',
                confirmButtonText: 'OK',
            });
            setFormData({
                name: '',
                email: '',
                message: ''
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: dataEdit.message,
                text: 'Error Submiting form!',
                confirmButtonText: 'OK',
            });
        }

    }


return (
    <>
        <section className="page-content sec-padding">
            <div className="container-fluid">
                <div className="page-content-details">
                    <div className="sec-title row">
                        <div className="col-md-6 text-start">
                            <h3>Contact Us</h3>
                        </div>
                    </div>
                    <div className="col-md-10 mx-auto">
                        <div className="card AddressView">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="name">Name:</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            className='form-control'
                                        // required 
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email">Email:</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className='form-control'
                                        // required 
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="message">Message:</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            className='form-control'
                                        // required a
                                        />
                                    </div>
                                    <button type="submit" className='btn btn-primary'>Submit</button>
                                </form>
                            </div>

                            <div className="additional-info">
                                <h1> OR </h1>
                                <p> Contact us directly on our Customer Care No. :  <span> 805-509-3784 </span> </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </section >
    </>
);
}

export default ContactUs;